import { useDownloadAlbumById } from '@bpm-web-app/swr-hooks';
import {
    downloadAlbumWithMediaToQueueItem,
    parseSeconds,
    showToast
} from '@bpm-web-app/utils';
import { useCallback } from 'react';
import AddToCrate from '../../assets/icons/add-to-crate.svg';
import AddToQueue from '../../assets/icons/add-to-queue.svg';
import FindSimilar from '../../assets/icons/find-similar.svg';
import { MobileDrawer } from '../mobile-drawer/mobile-drawer';
import { usePlayer } from '../player-context';
import { useCrates } from '../shared/three-dots-sheet/useCrates';
import styles from './versions-mobile-drawer.module.css';

export function VersionsMobileDrawer({
    isDownload,
    isOpen,
    onClose,
}: {
    isDownload?: boolean;
    isOpen: boolean;
    onClose: () => void;
}) {
    const {
        currentTrack,
        replaceCurrentPlayingTrack,
        addToQueue,
        setShowSimilarTracks,
        setIsMaxiPlayer
    } = usePlayer();

    const { data: downloadAlbumData } = useDownloadAlbumById(currentTrack?.album_id, isDownload);
    const { addMediaToOnlineCrate, addMediaToOfflineCrate } = useCrates();

    const addVersionToCrate = useCallback(
        (versionId) => {
            if (isDownload) {
                addMediaToOnlineCrate(versionId);
            } else {
                addMediaToOfflineCrate(versionId);
            }
        },
        [addMediaToOfflineCrate, addMediaToOnlineCrate, isDownload]
    );

    const addVersionToQueue = useCallback(
        (queueItem) => {
            addToQueue([queueItem]);
            showToast({ type: 'success', message: 'Added to queue.', buttonText: 'Open Queue', onButtonClick: () => setIsMaxiPlayer(true) });
        },
        [addToQueue, setIsMaxiPlayer]
    );

    const onItemClicked = useCallback((index: number) => {
        replaceCurrentPlayingTrack(downloadAlbumWithMediaToQueueItem(downloadAlbumData.data, index));
        onClose();
    }, [downloadAlbumData, onClose, replaceCurrentPlayingTrack]);

    return (
        <MobileDrawer isOpen={isOpen} onClose={onClose}>
            <div className={styles['versions-menu']}>
                {isDownload &&
                    downloadAlbumData?.data.media?.map((version, index) => (
                        <div key={version.id} className={styles['versions-menu__item']}>
                            <button
                                type="button"
                                // This should replace current playing track;
                                onClick={() => onItemClicked(index)}
                                aria-label={`Play ${version.name}`}
                                className={styles['versions-menu__item-play']}
                            >
                                <i className="icon icon--play" />
                            </button>
                            <div className={styles['versions-menu__item-title']}>{version.name}</div>
                            <button
                                type="button"
                                className={styles['versions-menu__item-button']}
                                onClick={() => addVersionToQueue(downloadAlbumWithMediaToQueueItem(downloadAlbumData.data, index))}
                            >
                                <AddToQueue />
                            </button>
                            <button type="button" className={styles['versions-menu__item-button']} onClick={() => addVersionToCrate(version.id)}>
                                <AddToCrate />
                            </button>
                            <button type="button" className={styles['versions-menu__item-button']} onClick={() => setShowSimilarTracks(true)}>
                                <FindSimilar />
                            </button>
                        </div>
                    ))}
            </div>
        </MobileDrawer>
    );
}
